export class Groupe_Politique {
     description:string;
     abreviation:string;
     id:number;
     constructor(data:any) {
         Object.assign(this, data);
     }
 
}
 